import _toConsumableArray from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetCustomers($limit: Int, $offset: Int, $searchValue: String) {\n    customers(limit: $limit, offset: $offset, searchValue: $searchValue) {\n      nodes {\n        ...customerInfo\n      }\n      totalCount\n    }\n  }\n  ", "\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
import customerFragment from '../../fragments/customer/customerInfo';
export var getCustomersQuery = gql(_templateObject(), customerFragment);
export var getCustomersQueryOptions = function getCustomersQueryOptions(searchValue) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return {
    variables: {
      limit: 10000,
      searchValue: searchValue
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  };
};
export var getCustomersFetchMore = function getCustomersFetchMore(fetchMore) {
  return function (offset) {
    fetchMore({
      variables: {
        offset: offset
      },
      updateQuery: function updateQuery(prev, _ref) {
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, _objectSpread(_objectSpread({}, fetchMoreResult), {}, {
          customers: _objectSpread(_objectSpread({}, fetchMoreResult.customers), {}, {
            nodes: [].concat(_toConsumableArray(prev.customers.nodes), _toConsumableArray(fetchMoreResult.customers.nodes))
          })
        }));
      }
    });
  };
};